// extracted by mini-css-extract-plugin
export default {"heading":"_3k9r1BRKAtjawvTw3KvYrz","container":"_17KQZij6usY91G0VHsTkQ4"};